"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNav = void 0;

var React = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _Monitoring = require("../../../scenes/Analysis/Monitoring");

var _types = require("../utils/types");

const SubNav = ({
  category,
  onChangeCategory
}) => /*#__PURE__*/React.createElement(_blocks.SecondaryNav, {
  hasBottomBorder: true
}, /*#__PURE__*/React.createElement(_blocks.Thirds, null, /*#__PURE__*/React.createElement(_blocks.Center, null, /*#__PURE__*/React.createElement(_blocks.SecondaryNavItem, {
  onClick: () => onChangeCategory(_types.Category.All),
  isActive: category === _types.Category.All
}, (0, _Monitoring.getMonitoringTitle)(_core.i18n, _types.Category.All)), /*#__PURE__*/React.createElement(_blocks.SecondaryNavItem, {
  onClick: () => onChangeCategory(_types.Category.Metering),
  isActive: category === _types.Category.Metering
}, (0, _Monitoring.getMonitoringTitle)(_core.i18n, _types.Category.Metering)), /*#__PURE__*/React.createElement(_blocks.SecondaryNavItem, {
  onClick: () => onChangeCategory(_types.Category.FDD),
  isActive: category === _types.Category.FDD
}, (0, _Monitoring.getMonitoringTitle)(_core.i18n, _types.Category.FDD)), /*#__PURE__*/React.createElement(_blocks.SecondaryNavItem, {
  onClick: () => onChangeCategory(_types.Category.Optimisation),
  isActive: category === _types.Category.Optimisation
}, (0, _Monitoring.getMonitoringTitle)(_core.i18n, _types.Category.Optimisation)), /*#__PURE__*/React.createElement(_blocks.SecondaryNavItem, {
  onClick: () => onChangeCategory(_types.Category.DataUptime),
  isActive: category === _types.Category.DataUptime
}, (0, _Monitoring.getMonitoringTitle)(_core.i18n, _types.Category.DataUptime)))));

exports.SubNav = SubNav;